export default __webpack_public_path__ + "media/images/icons/times-circle-solid-13560fb8dc6336072363bd43448f4cc4.svg";